/**
 * Slow editorial marquee. Not a shout — a whisper of place names
 * drifting horizontally at 60s per loop. Duplicated content for seamless loop.
 */
export default function Marquee({ items = [], className = "" }) {
  const doubled = [...items, ...items];
  return (
    <div className={`overflow-hidden ${className}`} aria-hidden>
      <div className="marquee-track">
        {doubled.map((item, i) => (
          <div
            key={i}
            className="flex items-center whitespace-nowrap px-8 md:px-14"
          >
            <span className="font-display text-[9vw] md:text-[7vw] leading-none font-light">
              {item}
            </span>
            <span
              className="mx-8 md:mx-14 inline-block h-[10px] w-[10px] rotate-45 border"
              style={{ borderColor: "var(--gold)" }}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
